function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';
import { useStoreActions } from "../../../contexts";
import CustomTooltip from "../charts/CustomTooltip/CustomTooltip";
import CustomXAxisTick from "../charts/CustomXAxisTick/CustomXAxisTick";
import CustomBarShape from "../charts/CustomBarShape/CustomBarShape";
import { chartColors } from "../charts/chartColors";
import { commonXAxisProps, commonBarChartProps, commonCartesianGridProps, commonBarProps } from "../charts/commonChartProps";
import { getBarLinkUrl, statusToText, getTooltipItems } from "./InvoicesWidget.utils";
export default function InvoicesChart(props) {
  const {
    chartData,
    testid
  } = props;
  const {
    logBI
  } = useStoreActions();

  const onBarClick = series => data => {
    logBI(11500, {
      column: statusToText[data.type],
      series,
      value: data[series]
    });
  };

  return /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement(BarChart, _extends({}, commonBarChartProps, {
    data: chartData
  }), /*#__PURE__*/React.createElement(CartesianGrid, commonCartesianGridProps), /*#__PURE__*/React.createElement(XAxis, _extends({}, commonXAxisProps, {
    dataKey: "type",
    tick: /*#__PURE__*/React.createElement(CustomXAxisTick, {
      tickWidth: 85,
      getText: props => statusToText[props.payload.value]
    }),
    height: 72
  })), /*#__PURE__*/React.createElement(YAxis, {
    hide: true
  }), /*#__PURE__*/React.createElement(Tooltip, {
    cursor: false,
    content: /*#__PURE__*/React.createElement(CustomTooltip, {
      testid: testid && "".concat(testid, "-tooltip"),
      getTitle: label => statusToText[label],
      getItems: getTooltipItems
    })
  }), /*#__PURE__*/React.createElement(Bar, _extends({}, commonBarProps, {
    dataKey: "requireAttention",
    stackId: "a",
    fill: chartColors.lightGray,
    shape: /*#__PURE__*/React.createElement(CustomBarShape, {
      hasRadius: true,
      testid: testid && "".concat(testid, "-requireAttention"),
      getLinkUrl: getBarLinkUrl
    }),
    onClick: onBarClick('requireAttention')
  })), /*#__PURE__*/React.createElement(Bar, _extends({}, commonBarProps, {
    dataKey: "expectedToBePaid",
    stackId: "a",
    fill: chartColors.green,
    shape: /*#__PURE__*/React.createElement(CustomBarShape, {
      hasRadius: true,
      testid: testid && "".concat(testid, "-expectedToBePaid"),
      getLinkUrl: getBarLinkUrl
    }),
    onClick: onBarClick('expectedToBePaid')
  }), /*#__PURE__*/React.createElement(LabelList, {
    position: "top",
    valueAccessor: entry => entry.expectedToBePaid || entry.requireAttention,
    fill: chartColors.labels,
    fontSize: 12
  }))));
}